import { Injectable } from '@angular/core';
import { SimuladorGoApi } from '@gestor-web/@core/api/go';
import { map } from 'rxjs/operators';

export interface PrestadoresAcreditados26Filtros {
  fil180Dias?: number;
  filAcreditado?: number;
  filRps?: string;
  filElegivel?: number;
}

@Injectable()
export class PrestadoresAcreditados26Service {
  constructor(private simuladorGoApi: SimuladorGoApi) {}

  fetchData(
    regans: string,
    competenciaInicial: string,
    competenciaFinal: string,
    filtros: PrestadoresAcreditados26Filtros = {},
  ) {
    return this.simuladorGoApi
      .fetchRelatorioPrestadoresAcreditados26({
        regans,
        competencia: competenciaInicial,
        competencia_final: competenciaFinal,
        fil_180_dias: filtros.fil180Dias,
        fil_acreditado: filtros.filAcreditado,
        fil_rps: filtros.filRps,
        fil_elegivel: filtros.filElegivel,
      })
      .pipe(map(data => data.items ?? []));
  }

  getUltimoProcessamento(regans: string) {
    return this.simuladorGoApi.fetchRelatorioPrestadoresAcreditados26UltimoProcessamento({ regans });
  }
}
